import { createApi } from '@reduxjs/toolkit/query/react';

import { ENVIRONMENT } from '../../constants/env-constants';
import { createBearerBaseQuery } from '../../shared/rtk-bearer-base-query';

export const usersApi = createApi({
  reducerPath: 'users-redux-query',
  baseQuery: createBearerBaseQuery(`${ENVIRONMENT.BACKEND_SERVER}/api/users`),
  tagTypes: ['User'],
  endpoints: (build) => ({
    getAllUserStats: build.query({
      query: ({ roleId, branchId }) => ({
        url: `/user-activity-overview-by-type?roleId=${roleId}&branchId=${branchId}&timezoneOffset=-5.5`,
      }),
    }),

    getUsers: build.query({
      query: () => ({
        cache: 'no-cache',
      }),
      providesTags: ['User'],
    }),

    createUser: build.mutation({
      query: (data) => ({
        url: '',
        method: 'POST',
        body: data,
      }),
    }),

    updateUser: build.mutation({
      query: ({ userId, data }) => ({
        url: `/${userId}`,
        method: 'PUT',
        body: data,
      }),
      async onQueryStarted({ userId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedUser } = await queryFulfilled;
          dispatch(
            usersApi.util.updateQueryData('getUsers', undefined, (draftUsers) => {
              const indexOldData = draftUsers.findIndex((user) => user.id === Number(userId));
              if (indexOldData > -1) draftUsers[indexOldData] = updatedUser;
            }),
          );
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
          // console.error('error:', error);
        }
      },
    }),

    disableUser: build.mutation({
      query: (userId) => ({
        url: `/${userId}`,
        method: 'DELETE',
      }),
      async onQueryStarted(userId, { dispatch, queryFulfilled }) {
        try {
          const { data: disabledUser } = await queryFulfilled;
          dispatch(
            usersApi.util.updateQueryData('getUsers', undefined, (draftUsers) => {
              const indexOldData = draftUsers.findIndex((user) => user.id === Number(userId));

              if (indexOldData > -1) draftUsers[indexOldData] = { ...draftUsers[indexOldData], ...disabledUser };
            }),
          );
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
          // console.error('error:', error);
        }
      },
    }),
  }),
});

export const {
  useCreateUserMutation,
  useGetAllUserStatsQuery,
  useGetUsersQuery,
  useDisableUserMutation,
  useLazyGetUsersQuery,
  useUpdateUserMutation,
} = usersApi;
